module.exports = "<div class=\"notfoundDiv\">\r\n\r\n   <div align=\"center\"><h3>404 - Pagina non trovata</h3></div>\r\n\r\n   <br />\r\n\r\n</div>\r\n"